var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { Icon } from '@inter-ikea-kompis/component-icon';
import IconPillSizeOptionsEnum from '../../enums/IconPillSizeOptionsEnum.js';
import IconPillStyle from './IconPillStyle.js';
/**
 * @deprecated This component has been deprecated, see Kompis page for more info.
 *
 * Icon Pill class.
 *
 * @event select Icon pill triggers props select event.
 */
export default class IconPill extends KompisElement {
    constructor() {
        super(...arguments);
        // Select
        this.selected = false;
        // Icon in the pill
        this.icon = null;
        // Disabled mode
        this.disabled = false;
        // Icon pill size option
        this.iconPillSize = IconPillSizeOptionsEnum.medium;
        // Label for the icon pill to set as an aria-label for accessibility reasons
        this.ariaLabel = null;
        this.hasFocus = false;
        this.pointerIsDown = false;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        return html `
			<style>
				${IconPillStyle.getStyle({
            hasFocus: this.hasFocus,
            iconPillSize: this.iconPillSize,
            selected: this.selected,
            isDisabled: this.disabled,
            theme: this.theme
        })}
			</style>
			<div
				class="iconPillButton"
				tabindex="0"
				role="checkbox"
				aria-label="${this.ariaLabel}"
				aria-checked="${this.selected}"
				aria-disabled="${this.disabled}"
				@focusout="${this.onFocusOut.bind(this)}"
				@focusin="${this.onFocus.bind(this)}"
				@click="${this.onChange.bind(this)}"
				@keydown="${this.onKeyDown.bind(this)}"
				@pointerdown="${this.onPointerDown.bind(this)}"
			>
				<div class="outline"></div>
				${this.getIcon()}
			</div>
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-icon', Icon);
        super.connectedCallback();
    }
    /**
     * Get the icon.
     *
     * @returns Template.
     */
    getIcon() {
        if (!this.icon) {
            return null;
        }
        return html ` <kompis-icon .theme="${this.theme}" .icon="${this.icon}"></kompis-icon> `;
    }
    /**
     * Event handler.
     *
     * @param event HTMLEvent.
     */
    onChange(event) {
        event.stopPropagation();
        event.preventDefault();
        if (this.disabled) {
            return;
        }
        this.dispatchEvent(new CustomEvent('select', {
            bubbles: true,
            detail: {
                selected: !this.selected
            }
        }));
        this.pointerIsDown = false;
    }
    /**
     * Event handler.
     *
     * @param event HTMLEvent.
     */
    onKeyDown(event) {
        if (this.disabled) {
            return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
            this.onChange(event);
        }
    }
    /**
     * HTML event handler.
     */
    onFocusOut() {
        if (this.hasFocus) {
            this.hasFocus = false;
            this.pointerIsDown = false;
            this.update();
        }
    }
    /**
     * HTML event handler.
     */
    onFocus() {
        if (this.pointerIsDown) {
            return;
        }
        this.hasFocus = true;
        this.update();
    }
    /**
     * HTML event handler.
     *
     */
    onPointerDown() {
        this.pointerIsDown = true;
        if (this.hasFocus) {
            this.hasFocus = false;
            this.update();
        }
    }
}
__decorate([
    property({ type: Boolean })
], IconPill.prototype, "selected", void 0);
__decorate([
    property({ type: String })
], IconPill.prototype, "icon", void 0);
__decorate([
    property({ type: Boolean })
], IconPill.prototype, "disabled", void 0);
__decorate([
    property({ type: String })
], IconPill.prototype, "iconPillSize", void 0);
__decorate([
    property({ type: String })
], IconPill.prototype, "ariaLabel", void 0);
__decorate([
    property({ type: Object, required: true })
], IconPill.prototype, "theme", void 0);
//# sourceMappingURL=IconPill.js.map